import { Theme } from './symbols';

export const darkTheme: Theme = {
  name: 'dark',
  properties: {
    // Icrisat 
    '--corecolour': '#262626',
    '--corecolour1': '#262626',
    '--corecolour-hover': '#1a1a1a',
    '--secondarycolour': '#115519',
    '--secondarycolour-hover': '#0d3f13',
    '--secondarycolour-mild': '#aaeeb2',
    '--tertiarycolour': '#28a745',
    '--checkbox-indcolour': '#ff6600',
    '--matformfield-colour': '#4d4d4d',
    '--sidetoggle-gradient1': '#404040',
    '--sidetoggle-gradient2': '#262626',
    '--fab-gradient1': '#23a932',
    '--fab-gradient2': '#115519',
    //Action button 
    '--actionbutton-gradient1': 'red',
    '--actionbutton-gradient2': 'maroon',
    //Divider Gradient 
    '--divider-gradient1': 'rgb(27, 142, 241)',
    '--divider-gradient2': 'rgb(27, 142, 241)',
    //Admin Gradient gold
    '--admin-gradient1': '#eed890',
    '--admin-gradient2': '#deb221',


    // //CrescoWorks 
    // '--corecolour': '#283e4a',
    // '--corecolour-hover': '#1b2a32',
    // '--secondarycolour': '#283e4a',
    // '--secondarycolour-hover': '#1b2a32',
    // '--secondarycolour-mild': '#8baec1',
    // '--checkbox-indcolour': 'rgb(27, 142, 241)',
    // '--matformfield-colour': '#283e4a',
    // '--sidetoggle-gradient1': '#537793',
    // '--sidetoggle-gradient2': '#2d4553',
    // '--fab-gradient1': '#3498db',
    // '--fab-gradient2': '#154360',
    // '--actionbutton-gradient1': 'red',
    // '--actionbutton-gradient2': 'maroon',
    // '--divider-gradient1': 'rgb(27, 142, 241)',
    // '--divider-gradient2': 'rgb(27, 142, 241)',
    // //Admin Gradient 
    // '--admin-gradient1': '#eed890',
    // '--admin-gradient2': '#deb221',
  }
};
